import * as React from "react";

function SvgIcons8Workflow(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M23 2.625L17.625 8h-3.719c-.469-2.273-2.5-4-4.906-4-2.75 0-5 2.25-5 5 0 2.406 1.727 4.438 4 4.906V18H4v10h10V18h-4v-4.094A5.06 5.06 0 0013.906 10H17.5l4.5 4.5v3.594c-2.273.468-4 2.5-4 4.906 0 2.75 2.25 5 5 5s5-2.25 5-5c0-2.406-1.727-4.438-4-4.906V14.5l5.438-5.438zm0 2.844l3.594 3.593L23 12.656l-3.594-3.594zM9 6c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3zM6 20h6v6H6zm17 0c1.668 0 3 1.332 3 3s-1.332 3-3 3-3-1.332-3-3 1.332-3 3-3z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Workflow);
